import { createSlice } from "@reduxjs/toolkit";
import { searchLabTests } from "../../reducer/searchLabTests/searchLabTestsReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const searchLabTestsSlice = createSlice({
  name: "searchLabTests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchLabTests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchLabTests.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(searchLabTests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default searchLabTestsSlice.reducer;
